import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export function saveInformationApi(_x) {
  return _saveInformationApi.apply(this, arguments);
}
function _saveInformationApi() {
  _saveInformationApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(param) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", usePost('/web/saveInformation', param));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _saveInformationApi.apply(this, arguments);
}